import { Currency } from '@/core/currency/interfaces';

const LBP: Currency = {
    name: 'Lebanese Pound',
    demonym: 'Lebanese',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '422',
    symbol: 'LL.',
    symbolNative: 'ل.ل.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'LBP',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default LBP;
